import GlobalErrorBoundary from './GlobalErrorBoundary';

export default GlobalErrorBoundary;
